// extracted by mini-css-extract-plugin
export var label = "_d5-1";
export var reminder = "_d5-0";